import clsx from "clsx";
import { LucideProps } from "lucide-react";
import React from "react";

import sharedStyles from "../../styles/shared/inputs.module.css";
import styles from "./index.module.css";

import dimensionTokens from "../../tokens/dimension.value.tokens.json";

const ICON_SIZE_MD = parseInt(dimensionTokens.component.icon.md.$value);
const ICON_SIZE_SM = parseInt(dimensionTokens.component.icon.sm.$value);

export interface ChipProps extends React.ComponentProps<"button"> {
  /** Children elements */
  children: React.ReactNode;
  /** Chip size */
  size?: "base" | "sm";
  /** Disabled state */
  isDisabled?: boolean;
  /** Selected state */
  isSelected?: boolean;
  /** Icon on left */
  iconLeft?: React.ReactElement<LucideProps>;
}

const Chip = React.forwardRef<HTMLButtonElement, ChipProps>(
  (
    {
      size = "base",
      children,
      iconLeft,
      isDisabled = false,
      isSelected = false,
      className,
      ...rest
    },
    ref
  ) => {
    const classes = clsx(
      styles.root,
      styles[size],
      {
        [sharedStyles.isDisabled]: isDisabled,
        [styles.isSelected]: isSelected,
      },
      className
    );

    const iconSize = size === "base" ? ICON_SIZE_MD : ICON_SIZE_SM;

    const clonedIconLeft =
      iconLeft && React.cloneElement(iconLeft, { size: iconSize });

    return (
      <button
        className={classes}
        disabled={isDisabled}
        aria-pressed={isSelected}
        type="button"
        ref={ref}
        {...rest}
      >
        {clonedIconLeft && (
          <span className={styles.icon}>{clonedIconLeft}</span>
        )}
        <span className={styles.text}>{children}</span>
      </button>
    );
  }
);

Chip.displayName = "Chip";
export default Chip;
